import { render, staticRenderFns } from "./singleFileUpload.vue?vue&type=template&id=45486bc9&scoped=true&"
import script from "./singleFileUpload.vue?vue&type=script&lang=js&"
export * from "./singleFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./singleFileUpload.vue?vue&type=style&index=0&id=45486bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45486bc9",
  null
  
)

export default component.exports